<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">{{ getTitle }}</h1>
          </div>
        </div>
        <router-link slot="right" :to="{ name: 'ListTemplates' }" class="button is-small is-link">
          Back to list</router-link>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <form autocomplete="off" @submit.prevent="addTemplate" name="SaveTemplate">
        <div>
          <card-component>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Template Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input class="input" type="text" required pattern="[a-zA-Z\s]+"
                      title="Enter Valid Template Name !" v-model.trim="templateObj.templateName"
                      maxlength="50" />
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">
                    Template Type
                    <span class="requir">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select :disabled="disabledType" @change="onChangeTemplateType($event)"
                      v-model.trim="templateObj.templateType">
                      <option :value="t" v-for="t in type" :key="t">{{ t }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Sender Key/TID
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input class="input" maxlength="15" required name="templateSenderKey"
                      v-model.trim="templateObj.templateSenderKey" />
                  </div>
                </div>
              </div>
              <div class="column is-6" v-show="smsdiv">
                <div class="field">
                  <label class="label">
                    Sender Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input class="input" maxlength="30" :required="requiredSms"
                      name="templateSenderName" v-model.trim="templateObj.templateSenderName" />
                  </div>
                </div>
              </div>
              <div class="column is-6 is-" v-show="emaildiv">
                <div class="field">
                  <label class="label">
                    Template Email Subject
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input class="input" :required="requiredEmail" name="templateEmailTemplate"
                      v-model.trim="templateObj.templateEmailSubject" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column is-6 is-">
                <div class="field">
                  <label class="label">
                    Template Page Type
                    <span class="requir">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select v-model.trim="templateObj.templatePageType" required>
                      <option value>---Select---</option>
                      <option :value="pageType" v-for="pageType in pageTypes" :key="pageType">
                        {{ pageType }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    User Type
                    <span class="requir">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select v-model.trim="templateObj.templateUserType" required>
                      <option :value="users" v-for="users in userType" :key="users">
                        {{ users }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns form-row" v-show="emaildiv">
              <div class="column is-10">
                <div class="field">
                  <label class="label"> Template Content </label>
                  <ckeditor :required="requiredEmail" v-model="templateContentEmail" ref="ckeditorRef"></ckeditor>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column is-6 is-" v-show="smsdiv">
                <div class="field">
                  <label class="label">
                    Template Content
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <textarea style="resize: none" :required="requiredSms" name="templateContent"
                      v-model.trim="templateContentSMS" class="input textarea is-medium"
                      maxlength="250"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <footer class="column has-text-right">
              <button class="button is-success" type="submit">Save</button>
            </footer>
          </card-component>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)

export default {
  name: 'SaveTemplate',
  props: ['templateId', 'title'],
  data () {
    return {
      disabled: false,
      getTitle: 'Add SMS/Email Template',
      data: [],
      loadingComponent: null,
      smsdiv: true,
      emaildiv: false,
      disabledType: false,
      requiredEmail: false,
      requiredSms: true,
      templateContentSMS: '',
      templateContentEmail: '',
      userType: constants.COMMUNICATION.TEMPLATE_USER_TYPE,
      type: constants.COMMUNICATION.TEMPLATE_TYPE,
      pageTypes: constants.COMMUNICATION.PAGE,
      templateObj: {
        templateName: '',
        templateType: 'SMS',
        templateSenderKey: '',
        templateSenderName: '',
        templatePageType: '',
        templateUserType: 'ALL',
        templateEmailSubject: '',
        templateContent: ''
      }
    }
  },

  created () {
    if (this.templateId) {
      this.getTitle = 'Edit Template'
      this.getTemplateDetails(this.templateId)
    } else {
      this.getTitle = 'Add SMS/Email Template'
    }
  },
  components: {
    CardComponent
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    const that = this.$refs.ckeditorRef
    const maximizedState = that.instance.getCommand('maximize').state
    if (maximizedState === 1) { that.instance.execCommand('maximize') }
    if (this.hasDataChanged() && !this.hasClicked) {
      return this.$buefy.dialog.confirm({
        title: 'Leave Page',
        message: 'Do you really want to leave? you have unsaved changes!',
        type: 'is-danger',
        cancelText: 'No',
        confirmText: 'Yes',
        onConfirm: () => { next() },
        onCancel: () => { next(false) }
      })
    } else next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert = (this.templateObj.templateName || this.templateObj.templateSenderKey ||
       this.templateObj.templateSenderName || this.templateObj.templatePageType || this.templateObj.templateEmailSubject ||
       this.templateObj.templateContent)
      return boolAlert
    },
    addTemplate: async function () {
      this.loadingComponent = this.$buefy.loading.open()
      this.hasClicked = true
      if (this.templateObj.templateType === 'EMAIL' && !this.templateContentEmail) {
        this.loadingComponent.close()
        return this.errMsg(`Please Add Email Template Content`)
      } else {
        if (this.templateObj.templateType === 'EMAIL') {
          this.templateObj['templateContent'] = window.btoa(this.templateContentEmail)
          this.templateObj.templateSenderName = null
        } else if (this.templateObj.templateType === 'SMS') {
          this.templateObj['templateContent'] = window.btoa(this.templateContentSMS)
          this.templateObj.templateEmailSubject = null
        }
        if (this.templateId) {
          try {
            await http.put(`${constants.API_URL}/api/communication/template/${this.templateId}`, this.templateObj)
            this.okMsg(`Template Update Successfully`)
            this.loadingComponent.close()
            this.$router.push({ name: 'ListTemplates' })
          } catch (e) {
            this.loadingComponent.close()
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            this.lock = false
            this.hasClicked = false
            this.errMsg(`Error While fetching Template: ${errorMessage}`)
          }
        } else if (this.templateObj.templateContent) {
          await http.post(`${constants.API_URL}/api/communication/template`, this.templateObj)
          this.okMsg(`Template Saved successfully`)
          this.loadingComponent.close()
          this.$router.push({ name: 'ListTemplates' })
        }
      }
    },
    getTemplateDetails: async function (templateID) {
      try {
        this.requiredFlag = true
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/communication/template/${templateID}`)
        this.loadingComponent.close()
        const templateObj1 = response.data
        if (templateObj1) {
          if (templateObj1.templateUserType === 'ENROLL') {
            templateObj1.templateUserType = 'PARENT'
          }
          this.templateObj = {
            templateName: templateObj1.templateName,
            templateType: templateObj1.templateType,
            templateSenderKey: templateObj1.templateSenderKey,
            templateSenderName: templateObj1.templateSenderName,
            templatePageType: templateObj1.templatePageType,
            templateEmailSubject: templateObj1.templateEmailSubject,
            templateUserType: templateObj1.templateUserType,
            templateContent: window.atob(templateObj1.templateContent)
          }
          this.disabledType = true
          if (templateObj1.templateType === 'SMS') {
            this.smsdiv = true
            this.emaildiv = false
            this.requiredSms = true
            this.requiredEmail = false
            this.templateContentSMS = window.atob(templateObj1.templateContent)
          } else if (templateObj1.templateType === 'EMAIL') {
            this.emaildiv = true
            this.smsdiv = false
            this.requiredEmail = true
            this.requiredSms = false
            this.templateContentEmail = this.templateObj.templateContent
          }
          return this.templateObj
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While fetching Template: ${errorMessage}`)
      }
    },
    onChangeTemplateType: function (event) {
      if (event.target.value === 'SMS') {
        this.smsdiv = true
        this.emaildiv = false
        this.requiredSms = true
        this.requiredEmail = false
      } else if (event.target.value === 'EMAIL') {
        this.emaildiv = true
        this.smsdiv = false
        this.requiredEmail = true
        this.requiredSms = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
pt>
